import React , { useState , useEffect} from 'react'
import addar from '../../../assets/img/addar.png'
import file from '../../../assets/img/file.png'
import delect from '../../../assets/img/delect.png'
import headset from '../../../assets/img/ggerhead.png'
import kyc2 from '../../../assets/img/kyc2.png'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Base_Url } from '../../globalvariable/globe'
import { ToastContainer, toast } from 'react-toastify';
import { ImageUrl } from '../../globalvariable/globe'
import ReactLoading from 'react-loading';
import Dot_arrow from '../cart_one/dot_arrow'
 
export default function Mob_kyc_two() {

  let navigate = useNavigate()
    let formData = new FormData();

    const [ img , setImg ] = useState()
    const [ imgs , setImgs ] = useState()
    const [ data , setData ] = useState('')
    const [ datas , setDatas ] = useState('')
    const user = localStorage.getItem('user_data')
    const [ loading , setLoading ] = useState(false)
    const [ aadharno , setAadharno ] = useState('')
    const [ aadharname , setAadharname ] = useState('')
    const [ pendkyc , setPendkyc ] = useState(false)
    const [ rejkyc , setRejkyc ] = useState(false)
    const [ kycstatus , setKcstatus ] = useState()
    let Aadharveri = /^[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}$/
    const [ good , setGood ] = useState(false)
    const [ alldata , allsetData ] = useState('')

    const  [ value1 , setValue1 ] = useState()
    const  [ value2 , setValue2 ] = useState()

    const [ valiaddno , setValiaddno ] = useState(false)
    const [ valiaddname , setValiaddname ] = useState(false)
    const [ suskyc , setSuskyc ] = useState(false)
    let backimage = '' ;
    var buthide=0;
    const errnotify = (data) => toast.error(data, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });

    useEffect(()=>{
        setLoading(false)
        setSuskyc(false)
        Alldata()
    },[])

    const addharChange = (e) =>{
      setAadharno(e.target.value.replace(/[^0-9]/g, "").slice(0, 12))
    }

    const Alldata = async () => {
        if(user===null){
            navigate('/')
            return
        }

        let responce = await axios({
            method : 'post',
            url : `${Base_Url}/kycUseraadhar`,
            headers: { 
                'Authorization': `Bearer ${user}` 
            }
        })
        .then((res)=>{
          
          allsetData(res.data)

          setKcstatus(res.data.Data.KycApproval)
            if(res.data.Data.KycApproval === 1 ){
              setSuskyc(true)
            }
            else if(res.data.Data.KycApproval === 0 ){
              setPendkyc(true)
            }else if(res.data.Data.KycApproval === 2 ){
              setRejkyc(true)
            }
            if(res.data.status === true){

              setAadharno(res.data.Data.KycDetail[0].KycUserAadharNo)
                setDatas(res.data.Data.KycDetail[0].KycUserAadharImg2)
                setData(res.data.Data.KycDetail[0].KycUserAadharImg)
                setAadharname(res.data.Data.KycDetail[0].KycUserAadharName)
                setValue1( res.data.Data.KycDetail[0].KycUserAadharName)
                setValue2(res.data.Data.KycDetail[0].KycUserAadharNo)
              //setData(res.data.Data.KycImage)
             // backimage = res.data.Data.KycImage

            }else{
              setPendkyc(true)
              
            }


            // if( res.data.status === true ){
                
            // }else{
            //   setData(res.data.Data.KycImage)
            //     console.log(res)
            // }
        })
        .catch((err)=>{
          if(err.response.status === 401){
            navigate('/login')
          }
        })
    }
    const imgFiles = (e) => {
      setGood(false)
      setDatas('')
      setImgs({'img' : URL.createObjectURL(e.target.files[0])})
  }

    const imgFile = (e) => {
        setGood(false)
        setData('')
        setImg({'img' : URL.createObjectURL(e.target.files[0])})
    }

    const remove = () =>{
        document.querySelector('#file').value = "";
        setImg()
        setData('')
        setGood(true)
    }
    const removes = () =>{
      document.querySelector('#files').value = "";
      setImgs()
      setDatas('')
      setGood(true)
  }

    const Clicked = async() => {
        setLoading(true)

        if(good === true ){
          setLoading(false)
          errnotify('Upload Image')
          return
        }

        if( aadharno === '' || aadharname === ''){
            if( aadharno === '' ){
                setValiaddno(true)
                setLoading(false)
            }else{
                setValiaddno(false)
                setLoading(false)
            }
            if ( aadharname === '' )            {
                setValiaddname(true)
                setLoading(false)
            }else{
                setValiaddname(false) 
                setLoading(false)
            }
            return 
        }else{
            setValiaddname(false)
            setValiaddno(false)
        }


        let imagefile = document.querySelector('#file');
        let imagefiles = document.querySelector('#files');

        if(imagefile == null){
          console.log('worked')
          errnotify('Upload Front Image')
          setLoading(false)
          return
        }

        if(imagefiles == null){
          console.log('worked')
          errnotify('Upload Back Image')
          setLoading(false)
          return
        }
        formData.append("aadharImg", imagefile.files[0]);
        formData.append("aadharNo", aadharno);
        formData.append("aadharName", aadharname);
        formData.append("aadharImg2", imagefiles.files[0]);
        if(imagefile.files[0] == undefined){
          console.log('worked')
          errnotify('Upload Front Image')
          setLoading(false)
          return
        }
        if(imagefiles.files[0] == undefined){
          console.log('worked')
          errnotify('Upload Back Image')
          setLoading(false)
          return
        }
        if(value1 === aadharname && value2===aadharno){
          
        }else{
          let responce = await axios.post( `${Base_Url}/kycUseraadhar`, formData, {
            headers: {
                'Authorization': `Bearer ${user}` ,
                'Content-Type': 'multipart/form-data'
            } 
        })
        .then((res)=>{
            navigate('/kyc_three')
            setLoading(false)
            console.log(res)
        })
        .catch((err) =>{
            setLoading(false)
            if(err.response.status === 401){
              navigate('/login')
            }
            console.log(err)
        })
        return
        }
        

        if(data != '' && datas != ''){
          navigate('/kyc_three')
          setLoading(false)
          return
      }
      
        
        let responce = await axios.post( `${Base_Url}/kycUseraadhar`, formData, {
            headers: {
                'Authorization': `Bearer ${user}` ,
                'Content-Type': 'multipart/form-data'
            } 
        })
        .then((res)=>{
            navigate('/kyc_three')
            setLoading(false)
            console.log(res)
        })
        .catch((err) =>{
            setLoading(false)
            if(err.response.status === 401){
              navigate('/login')
            }
            console.log(err)
        })
    }
    const Clickedone = () => {
      console.log('epic fail')
      navigate('/kyc_three')
    }

    const gotosupport =()=>{
      navigate('/support')
  }

  return (
    <>
    {
      kycstatus === 1 ? '' : <img style={{ width : '100%' }} src={kyc2} />
    }
    <div className='mt-4'>
          <div className='row'>
              <div className='col-2'>
              {
                              alldata?.status === false ? 
                              <div class="donut-ring">
                                <div className={kycstatus === 1 ? "ring red" : "ring red"}></div>
                                <div className={kycstatus === 1 ? "ring blue" : "ring blue"}></div>
                                <div className={kycstatus === 1 ? "ring orange" : "ring orangetwo"}></div>
                                <div className={kycstatus === 1 ? "ring grrreeeennn4" : "ring green"}></div>
                                <div className="cutout">
                                  <p className='kyc_p_one'>2 Of 4</p>
                                </div>
                              </div>
                              : kycstatus === 1 ? 
                                <div class="donut-ring">
                                  <div className={kycstatus === 1 ? "ring red" : "ring red"}></div>
                                  <div className={kycstatus === 1 ? "ring blue" : "ring blue"}></div>
                                  <div className={kycstatus === 1 ? "ring orangegreenss" : "ring orange"}></div>
                                  <div className={kycstatus === 1 ? "ring grrreeeennn4" : "ring green"}></div>
                                  <div className="cutout">
                                    <p className='kyc_p_one'>2 Of 4</p>
                                  </div>
                                </div>
                              :
                               kycstatus === 0 ? 
                                <div class="donut-ring">
                                  <div className={kycstatus === 1 ? "ring red" : "ring red"}></div>
                                  <div className={kycstatus === 1 ? "ring blue" : "ring blue"}></div>
                                  <div className={kycstatus === 1 ? "ring orange" : "ring orangetwoss"}></div>
                                  <div className={kycstatus === 1 ? "ring grrreeeennn4" : "ring yellowonw"}></div>
                                  <div className="cutout">
                                    <p className='kyc_p_one'>2 Of 4</p>
                                  </div>
                                </div>
                              :
                              kycstatus === 2 ? 
                              <div class="donut-ring">
                                <div className="ring red"></div>
                                <div className="ring blue"></div>
                                <div className="ring orangered444"></div>
                                <div className= "ring redones"></div>
                                <div className="cutout">
                                  <p className='kyc_p_one'>2 Of 4</p>
                                </div>
                              </div>
                            : 
                            ''

                            }
              </div>
              <div className='col-10'>
                  <div className='d-flex justify-content-between'>
                    <div>
                      <p className='kyc_p_two'>Step 2</p>
                      <p style={{ marginLeft : 10 }} className='kyc_p_four'>Aadhar</p>
                    </div>
                    
                    {
                      kycstatus === 0 ? <p style={{ color: '#cfcf00', fontSize: '12', fontWeight: '600' }} >Pending</p> : kycstatus === 1 ? <p style={{ color: 'green', fontSize: '12', fontWeight: '600' }} >Approved</p> : kycstatus === 2 ? <p style={{ color: 'red', fontSize: '12', fontWeight: '600' }} >Rejected</p> : ''
                    }
                </div>
              </div>
          </div>
      </div>
        <div className='mt-4'>
        <div >
            <p className='kyc_two_para'>Aadhar Name</p>
            <input type="text" disabled={suskyc ? 'disabled' : ''}
              onChange={(e)=> {
                let letters = /^[1-9][0-9]*$/;
                let last = ''
                if(e.target.value.length >=2) {
                    last = e.target.value.split('').pop()
                }else{
                    last = e.target.value
                }
                if(last.match(letters)){

                }else{
                    console.log(e)
                    setAadharname(e.target.value)
                }
              }}
            value={aadharname} className="form-control kyc_in_one" id="exampleInputEmail1" aria-describedby="emailHelp" />
            {
              valiaddname ? <p style={{color:'red',fontSize:'9px'}}>Enter Valid AadharName</p> : ''
            }
          </div>
          <div className='mt-3'> 
            <p className='kyc_two_para'>Aadhar No</p>
            <input  onChange={(e)=>addharChange(e)} value={aadharno} className="form-control kyc_in_one" id="exampleInputEmail1" disabled={suskyc ? 'disabled' : ''}  aria-describedby="emailHelp"  />
            {
              valiaddno ? <p style={{color:'red',fontSize:'9px'}}>Enter Valid AadharName</p> : ''
            }
          </div>
          
        </div>
        <div className='mt-3 pb-5'>
          <p className='kyc_p_four'>Upload Aadhar Card</p>
          <p className='kyc_p_four my-2'>Front Side</p>
          <div className='kyc_cont'>
            {
              data ? <img className='kyc_img_one' style={{width:'100%'}} src={ ImageUrl + '/' + data } />  : img ? <img className='kyc_img_one' style={{width:'100%'}} src={img.img} /> : alldata?.status === false ?
              <img  className='kyc_img_one img_opacttty'  src={addar} /> : kycstatus === 2 ? <img  className='kyc_img_one img_opacttty'  src={addar} />  : ''
            }   
                          {(() => {

if((suskyc == true)){
  var buthide=1;
}else if((pendkyc == true) &&  (data != '')){
  var buthide=1;
}else if((pendkyc == true) &&  (data == '')){
  var buthide=0;
}else if((rejkyc == true)){
  var buthide=0;
}

})()}
            <div class="kyc_centered ">
            {(() => {
              if(suskyc == false || rejkyc == true || (pendkyc == true) &&  (data == '')){ return(
                <div className='kyc_cont_two'>
                    <div className='d-flex justify-content-around'>
                      <div className='kyc_cont_two_upload mt-2'>
                          <img className='kyc_cont_two_upload_two kyc_img_one kyc_img_one' src={file} />
                          <input style={{ width :  50 }}  onChange={(e)=>imgFile(e)} accept="image/*" name='file' className='kyc_cont_two_upload_three' id='file' type="file" />
                      </div>
                        <div className='mt-2 kyc_line'>
                        </div>
                        <div className=' mt-2'>
                            <img onClick={()=>remove()} src={delect} />
                        </div>
                    </div>
                </div>)
              }
                })()}
            </div>
          </div>
          <p className='kyc_p_four my-3'>Back Side</p>
                        <div style={{marginBottom:'50px'}} className='kyc_cont'>
                            {
                                datas ? <img style={{width:'100%'}} className='kyc_img_one' src={ ImageUrl + '/' + datas } />  : imgs ? <img style={{width:'100%'}} className='kyc_img_one' src={imgs.img} /> : alldata?.status === false ?
                                <img  className='kyc_img_one img_opacttty'  src={addar} /> : kycstatus === 2 ? <img  className='kyc_img_one img_opacttty'  src={addar} />  : ''
                            }
                             {(() => {
              if(suskyc == false || rejkyc == true || (pendkyc == true) &&  (data == '')){ return(      
                                <div class="kyc_centered">
                                    <div className='kyc_cont_two'>
                                        <div className='d-flex justify-content-around'>
                                            <div className='kyc_cont_two_upload mt-2'>
                                                <img className='kyc_cont_two_upload_two kyc_img_one kyc_img_one' src={file} />
                                                <input style={{ width :  50 }}  onChange={(e)=>imgFiles(e)} accept="image/*" name='files' className='kyc_cont_two_upload_three' id='files' type="file" />
                                            </div>
                                            <div className='mt-2 kyc_line'>
                                            </div>
                                            <div className=' mt-2'>
                                                <img onClick={()=>removes()} src={delect} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                          }
                            })()}
                        </div>
      </div>
      <div className='mob_footss'>
          <div className='row'>
              <div className='col-6'>
                  <div onClick={()=>gotosupport()} className='d-flex'>
                      <div className='headset'>
                        <img className='kaart' src={headset} />
                      </div>
                      <div>
                        <p className='compara222'>Support</p>
                        <p className='compara333'>9am - 5Pm</p>
                      </div>
                  </div>
              </div>
              
              <div className='col-6'>



              {(() => {
console.log(pendkyc,'dfgfdg')
console.log(data,'data')
if((suskyc == true)){
 return(<div onClick={()=> Clickedone() } className='bbtn'>
                     <div className='d-flex'>
                         <p style={{cursor:'pointer'}} className='compara nextonee mt-1'>{loading ?
                         <div style={{marginLeft:'-47px' , marginTop : '-4px'}}>
                           <ReactLoading type='balls' color='#ffffff' />
                         </div>
                            : 'Next'}</p>
                     </div>
                 </div>)
}else if((pendkyc == true) &&  (data != '')){
 return(<div onClick={()=> Clickedone() } className='bbtn'>
 <div className='d-flex'>
     <p style={{cursor:'pointer'}} className='compara nextonee mt-1'>{loading ?
     <div style={{marginLeft:'-47px' , marginTop : '-4px'}}>
       <ReactLoading type='balls' color='#ffffff' />
     </div>
        : 'Next'}</p>
 </div>
</div>)
}else if((pendkyc == true) &&  (data == '')){
 return(<div onClick={()=> Clicked() } className='bbtn'>
                     <div className='d-flex'>
                         <p style={{cursor:'pointer'}} className='compara nextonee mt-1'>{loading ?
                         <div style={{marginLeft:'-47px' , marginTop : '-4px'}}>
                           <ReactLoading type='balls' color='#ffffff' />
                         </div>
                            : 'Next'}</p>
                     </div>
                 </div>)
}else if((rejkyc == true)){
 return(<div onClick={()=> Clicked() } className='bbtn'>
                     <div className='d-flex'>
                         <p style={{cursor:'pointer'}} className='compara nextonee mt-1'>{loading ?
                         <div style={{marginLeft:'-47px' , marginTop : '-4px'}}>
                           <ReactLoading type='balls' color='#ffffff' />
                         </div>
                            : 'Next'}</p>
                     </div>
                 </div>)
}else{
  return(
    ''
  )
}

               })()}
              </div>
          </div>
      </div>
    <ToastContainer />
    </>
  )
}